const PDF_HEADER_FOOTER_CONSTANTS = {
  MIN: 0,
  MAX: 0.25,
  DEFAULT: 0.15
}

const SYNTHETIC_EMAIL_SUFFIX = 'synthetic_test@getrodeo.io'
const DATADOG_EMAIL_SUFFIX = '@synthetics.dtdg.co'
const SYNTHETIC_COMPANYNAME_PREFIX = 'synthetic_test_'
const E2E_SINGLE_TEAM_EMAIL = 'test@getrodeo.io'
const E2E_MULTI_TEAM_EMAIL = 'e2e@getrodeo.io'

const POLYMER_GLIDER_CLIENT_IDS = {
  activityCommentAttachment: 'POLYMER_GLIDER_ACTIVITY_COMMENT_ATTACHMENT_PATH',
  pdfBackground: 'POLYMER_GLIDER_PDF_BACKGROUND',
  pdf: 'POLYMER_GLIDER_PDF'
}

const PROJECT_PHASE_STATUSES = {
  estimate: 'estimate',
  active: 'active',
  completed: 'completed',
  closed: 'closed'
}

const PO_STATUSES = {
  open: 'Open',
  draft: 'Draft',
  closed: 'Closed'
}

const SUBSCRIPTION_TYPES = {
  free: 'free'
}

const TASK_PRIORITIES = {
  trivial: 'Trivial',
  minor: 'Minor',
  major: 'Major',
  critical: 'Critical',
  blocker: 'Blocker'
}

module.exports = {
  ALLOWED_UPLOAD_FILE_TYPES: {
    png: 'image/png',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    gif: 'image/gif',
    pdf: 'application/pdf',
    csv: 'text/csv',
    xls: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    zip: 'application/zip',
    xml: 'application/xml',
    ppt: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    doc: 'application/msword',
    docs: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    txt: 'text/txt'
  },
  PHASE_TYPES: {
    DISCOUNT: 'discount',
    REGULAR: 'regular'
  },
  SUPPORTED_COUNTRIES: ['NL', 'US', 'DE', 'UK'],
  LANGUAGE_BY_COUNTRY: {
    NL: 'NL',
    DE: 'DE',
    US: 'US',
    UK: 'EN'
  },
  SUPPORT_ACCOUNTS: {
    NL: 'support@getrodeo.io',
    US: 'support@rodeo-app.com',
    UK: 'support@rodeo-app.co.uk',
    DE: 'support@rodeo-app.de'
  },
  DEFAULT_COUNTRY: 'NL',
  TIME_RATE_CARD: 'time-rate-card',
  EXPENSE_RATE_CARD: 'expense-rate-card',
  // decimal separator per team country
  DECIMAL_SEPARATOR: {
    NL: ',',
    DE: ',',
    US: '.',
    UK: '.'
  },
  LEADS_EMAIL: 'leads@getrodeo.io',
  MAIL_SERVICES_TIMEOUT: 30000,
  PDF_HEADER_HEIGHT: PDF_HEADER_FOOTER_CONSTANTS,
  PDF_FOOTER_HEIGHT: PDF_HEADER_FOOTER_CONSTANTS,
  CHECKOUT_SERVICE_ACTIONS: {
    CHECKOUT: 'checkout',
    PAYMENT_CONFIG: 'payment-config'
  },
  RATING_EXEMPTED_EMAIL_DOMAINS: [
    'kopofmunt.com',
    'getrodeo.io',
    'rodeo-app.com',
    'rodeo-app.nl',
    'rodeo-app.co.uk'
  ],
  REPORTS: {
    EMPLOYEE_PRODUCTIVITY: 'employee-productivity',
    EMPLOYEE_PRODUCTIVITY_V2: 'employee-productivity-v2',
    TIME_REGISTRATION: 'time-registration',
    WORK_IN_PROGRESS: 'work-in-progress',
    CLOSED_PROJECTS: 'closed-projects',
    CLOSED_PROJECTS_V2: 'closed-projects-v2',
    PLANNER_OVERVIEW: 'planner-overview'
  },
  DATE_TIME_FORMATS: [
    'YYYY-MM-DDTHH:mm:ss.sssZ',
    'YYYY-DD-MMTHH:mm:ss.sssZ',
    'DD-MM-YYYYTHH:mm:ss.sssZ',
    'MM-DD-YYYYTHH:mm:ss.sssZ'
  ],
  NEW_RELIC_LOGS_ENDPOINT: 'https://log-api.eu.newrelic.com/log/v1',
  SYNTHETIC_TEST_EMAIL_REGEX: new RegExp(SYNTHETIC_EMAIL_SUFFIX + '$'),
  DATADOG_TEST_EMAIL_REGEX: new RegExp(DATADOG_EMAIL_SUFFIX + '$'),
  SYNTHETIC_TEST_COMPANYNAME_REGEX: new RegExp('^' + SYNTHETIC_COMPANYNAME_PREFIX),
  E2E_SINGLE_TEAM_EMAIL,
  E2E_MULTI_TEAM_EMAIL,
  EMPTY_ADDRESS: {
    street: '',
    postcode: '',
    streetNumber: '',
    city: '',
    state: '',
    country: ''
  },
  UI_AVATARS_API_URL: 'https://eu.ui-avatars.com/api/',
  VAT_RATES_PER_COUNTRY: {
    NL: [21, 9, 0],
    DE: [19, 16, 7, 5, 0],
    UK: [20, 5, 0],
    US: [0]
  },
  DEFAULT_VAT_RATES_PER_COUNTRY: {
    NL: 21,
    UK: 20,
    DE: 16,
    US: 0
  },
  VAT_RATES_REVERSE_CHARGED: [0],
  VAT_IS_NOT_SUPPORTED_IN_COUNTRY_CODES: ['US'],
  EUROPEAN_COUNTRIES_CODES: [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MC',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE'
  ],
  PROJECT_PHASE_STATUSES,
  SUBSCRIPTION_TYPES,
  TASK_PRIORITIES,
  PO_STATUSES,
  POLYMER_GLIDER_CLIENT_IDS
}
